import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';


// Connects to data-controller="ordering-question"
export default class extends Controller {
  static values = [
    {
      sort: { type: Boolean, default: true } ,
      swap: { type: Boolean, default: false }
    }
  ]

  connect() {
    new Sortable(this.element, {
      group: {
        name: this.element.id,
        put: function (to) {
          const isTargetList = to.el.dataset.isTargetList;
          const isSourceList = !isTargetList;
          const emptyTargetList = to.el.querySelectorAll('.list-group-item').length == 0;

          return isSourceList || (isTargetList && emptyTargetList);
        }
      }, // set both lists to same group
      animation: 300,
      sort: this.sortValue,
      swap: this.swapValue,
      onEnd: this.onEnd,
      // direction: 'horizontal', // Direction of Sortable (will be detected automatically if not given)

    });
  }

  onEnd (/**Event*/evt) {
    const item = evt.item;  // dragged HTMLElement
    const target_list = evt.to;    // target list
    const from_list = evt.from;  // previous list

    const match_value = item.dataset.matchValue;

    // set answer if putting in target list
    if (target_list.dataset.isTargetList) {
      const to_answer_field = target_list.querySelector('.match_answer');
      to_answer_field.value = match_value;
    }

    // remove answer if moving out from target list
    if (from_list.dataset.isTargetList) {
      const from_answer_field = from_list.querySelector('.match_answer');
      from_answer_field.value = null;
    }
  }
}
